// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PnmIntCreateLeadEntityMapper$PorterinFeature from "./mapper/PnmIntCreateLeadEntityMapper.mjs";
import * as ResponseHandler$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ResponseHandler.mjs";
import * as PnmIntGeoValidationEntityMapper$PorterinFeature from "./mapper/PnmIntGeoValidationEntityMapper.mjs";
import * as PnmIntShiftReqBasicDetailsEntityMapper$PorterinFeature from "./mapper/PnmIntShiftReqBasicDetailsEntityMapper.mjs";
import * as PnmIntShiftReqLocationDetailsEntityMapper$PorterinFeature from "./mapper/PnmIntShiftReqLocationDetailsEntityMapper.mjs";

var execute = PnmIntGeoValidationEntityMapper$PorterinFeature.execute;

var GeoValidationApiConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var GeoValidationResponseConverter = partial_arg(GeoValidationApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

var execute$1 = PnmIntCreateLeadEntityMapper$PorterinFeature.execute;

var CreateLeadApiConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var CreateLeadResponseConverter = partial_arg$1(CreateLeadApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

var execute$2 = PnmIntShiftReqBasicDetailsEntityMapper$PorterinFeature.execute;

var ShiftReqBasicDetailsApiConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var ShiftReqBasicDetailsResponseConverter = partial_arg$2(ShiftReqBasicDetailsApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

var execute$3 = PnmIntShiftReqLocationDetailsEntityMapper$PorterinFeature.execute;

var ShiftReqLocationDetailsApiConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var ShiftReqLocationDetailsResponseConverter = partial_arg$3(ShiftReqLocationDetailsApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

export {
  GeoValidationApiConfig ,
  GeoValidationResponseConverter ,
  CreateLeadApiConfig ,
  CreateLeadResponseConverter ,
  ShiftReqBasicDetailsApiConfig ,
  ShiftReqBasicDetailsResponseConverter ,
  ShiftReqLocationDetailsApiConfig ,
  ShiftReqLocationDetailsResponseConverter ,
}
/* GeoValidationResponseConverter Not a pure module */
